import PurchaseTrainingCheckoutModal from './PurchaseTrainingCheckoutModal.vue';

export default PurchaseTrainingCheckoutModal;
